import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDeleteIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.2,
		d: "M4.166 5.833h11.667m-.833 0V15c0 .92-.746 1.667-1.667 1.667H6.667A1.667 1.667 0 0 1 5 15V5.833m7.5-2.708h-5m.833 6.042v4.166m3.334-4.166v4.166"
	})
});
export default SvgDeleteIcon;
